import $ from 'jquery'

export const initEventTickets = () => {
  
  $('body').on("change", "#tickets-select", onEventIdChange)

}

const onEventIdChange = (e) => {
  const select = e.currentTarget
  const url = select.dataset.url
  const target = select.dataset.target
  const targetEl = target ? document.querySelector(target) : false
  if (!url || !targetEl) {
    console.log("url or target unknown")
    return false;
  }
  targetEl.innerHTML = ""
  $.get(url, {event_id: select.value}, (response) => {
    targetEl.innerHTML = response
  })
  
}